export default __webpack_public_path__ + "static/illustration-3-cropped-0482e5ede7423b1973f042afa6347743.png";